<div class="search-bar search-bar-v2">
  <em class="icon-liteicons-search"></em>
  <input (keyup)="searchEvent($event)" type="text" [placeholder]="placeholder" [(ngModel)]="searchObj.text" />
  <a *ngIf="searchObj?.text" (click)="clearSearch()" class="icon-close">
    <em>&#x2715;</em>
  </a>
</div>